<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số hóa đơn' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.invoiceNum"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="" style="position: relative">
                  <CalendarRange
                    v-model="searchParams.date"
                    mode="date"
                    :disabled="disableHasInvoice"
                    @input="onDatePickerChange"
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Tài khoản thu ngân' }}
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['full_name', 'code', 'name']"
                    :selected-index-field-value="searchParams.accountID"
                    :value="searchParams.accountID"
                    :rows="accountRows"
                    :disabled="disableHasInvoice"
                    :columns="accountCols"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectAccount"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.code || ''} - ${
                              selectedData?.full_name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.hotelIds"
                    :disabled="disableHasInvoice"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo tiền mặt` }}
              </span>
            </div>

            <DownloadBtn
              @exportExcel="exportExcel"
              @openNoteDialog="dialogNoteVisible = true"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridEnterprise
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              style="height: 100%"
              dom-layout="scroll"
              :suppress-row-click-selection="true"
              :suppress-row-transform="true"
              :pinned-bottom-row-data="pinnedBottomRowData"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Số hóa đơn: Hiển thị số hóa đơn theo phương thức thanh toán bằng
              tiền mặt
            </li>
            <li>Số tiền: Hiển thị số tiền của hóa đơn</li>
            <li>Ngày: Ngày có giao dịch được thanh toán bằng tiền mặt</li>
            <li>
              Tài khoản thu ngân: Tài khoản thực hiện thanh toán bằng tiền mặt
            </li>
            <li>
              Tổng: Hiển thị tổng số tiền của 1 tài khoản thu ngân trong khoảng
              thời gian tìm kiếm
            </li>
            <li>
              Tổng cộng: hiển thị tổng số tiền của tất cả các tài khoản thu ngân
              đã phát sinh giao dịch thanh toán bằng tiền mặt
            </li>
            <li>
              '+-' cho Phép người dùng có thể xem Tổng tiền của từng thu ngân
              hoặc xem chi tiết từng hóa đơn của từng thu ngân
            </li>
            <li style="font-weight: bold">Lưu ý</li>
            <ul>
              <li>
                Với những cột là số tiền: tự động hiển thị dấu phẩy phân tách.
                Ví dụ: 100000(1 trăm) hiển thị: 100,000
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import { getAllHotel } from '@/api/hotel'
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'
import { formatVND } from '@/utils/commonUtils'

import {
  getCashReport,
  getCashReportExcel
} from '@/api/report_service/datntReport'
import { getAccount } from '@/api/reception/common'

export default {
  components: { DownloadBtn, NoteDialog, CalendarRange },
  data() {
    return {
      searchParams: {
        invoiceNum: null,
        accountID: null,
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null,
        hotelIds: []
      },
      defaultSearchParams: {
        invoiceNum: null,
        accountID: null,
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null,
        hotelIds: []
      },

      // input
      disableInvoiceNum: true,
      disableHasInvoice: false,

      // data for search
      hotelList: [],
      accountRows: [],
      accountCols: [
        {
          headerName: 'Tên',
          field: 'full_name',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Code',
          field: 'code',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],

      // grid
      rows: [],
      pinnedBottomRowData: [],

      // dialog
      dialogNoteVisible: false
    }
  },

  computed: {
    columns() {
      return [
        { headerName: '', field: 'account_name', rowGroup: true, hide: true }, // col-1
        {
          headerName: 'Số hóa đơn',
          field: 'invoice_number_sequence',
          maxWidth: 200,
          cellClassRules: {
            sumRow: params => params.data?.rowClass === 'sumRow'
          }
        },
        {
          headerName: 'Số tiền',
          field: 'money',
          cellRenderer: params => formatVND(params.data.money, null),
          cellClass: 'ag-cell-right',
          cellClassRules: {
            sumRow: params => params.data?.rowClass === 'sumRow'
          }
        },
        {
          headerName: 'Ngày',
          field: 'date',
          cellClassRules: {
            sumRow: params => params.data?.rowClass === 'sumRow'
          }
        },
        {
          headerName: 'Tài khoản thu ngân',
          field: 'account_name',
          cellClassRules: {
            sumRow: params => params.data?.rowClass === 'sumRow'
          }
        }
      ]
    }
  },

  watch: {
    'searchParams.invoiceNum'(nv, ov) {
      if (nv) {
        this.disableHasInvoice = true
        this.searchParams.date = {
          start: null,
          end: null
        }
        this.searchParams.accountID = null
        this.searchParams.hotelIds = null
      } else {
        this.disableHasInvoice = false
        this.searchParams = { ...this.defaultSearchParams }
      }
    }
  },

  async mounted() {
    window.rowSpan = params => {
      if (params.data?.rowClass === 'firstRow') {
        return params.data?.countRows
      } else {
        return 1
      }
    }
    window.cellStyle = params => {
      if (params.data?.rowClass === 'firstRow' && params.data?.countRows > 1) {
        return {
          backgroundColor: 'white !important',
          top: 0,
          borderBottom: `1px solid rgba(189, 195, 199, 0.58)`,
          height: `calc(${params.data?.countRows} * ${DEFAULT_GRID_ROW_HEIGHT}px) !important`,
          display: 'flex',
          alignItems: 'center'
        }
      }
      return null
    }
    // window.cellClassRules = {
    //   headerRow: params => params.data?.rowClass === 'headerRow',
    //   groupRow: params => params.data?.rowClass === 'groupRow',
    //   sumRow: params => params.data?.rowClass === 'sumRow'
    // }

    // normal data
    await this.getListAccount()
    await this.getListHotel()
    await this.fnGetCashReport()
  },

  methods: {
    onSearch() {
      this.fnGetCashReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.disableInvoiceNum = true
      this.disableHasInvoice = false
      this.fnGetCashReport()
    },
    // selectChange(selectedValue) {},
    onSelectAccount(selected) {
      this.searchParams.accountID = selected?.id
    },

    // onDatePickerChange() {
    //   // console.log(this.searchParams.date)
    //   if (this.searchParams.date.end || this.searchParams.date.start) {
    //     this.disableInvoiceNum = true
    //   } else {
    //     this.disableInvoiceNum = false
    //   }
    // },

    // handle api call
    async getListAccount() {
      const res = await getAccount({ userGroupNames: ['FO-All', 'Sale-All'] })
      this.accountRows = res.data.map(item => {
        return {
          id: item.account.id,
          code: item.account.code,
          full_name: item.account.full_name
        }
      })
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    exportExcel() {
      const query = {
        invoiceNum: this.searchParams.invoiceNum,
        accountID: this.searchParams.accountID,
        dateFrom: this.searchParams.date.start,
        dateTo: this.searchParams.date.end,
        hotelIds: this.searchParams.hotelIds
      }
      getCashReportExcel(query).then(res => {
        if (res) {
          const date = this.$moment().format('DD-MM-YYYY')
          const href = URL.createObjectURL(res)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute(
            'download',
            'cash_report_' + date + '.xlsx'
            // res.headers['content-disposition'].split('filename=')[1],
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        } else {
          throw new Error(res)
        }
      })
    },
    async fnGetCashReport() {
      try {
        const query = {
          invoiceNum: this.searchParams.invoiceNum,
          accountID: this.searchParams.accountID,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end,
          hotelIds: this.searchParams.hotelIds
        }
        const res = await getCashReport(query)
        this.rows = res.data.map(item => {
          if (item?.total) {
            return {
              invoice_number_sequence: 'Tổng',
              money: item.total
            }
          }
          if (item?.total_all !== undefined) {
            return {
              invoice_number_sequence: 'Tổng cộng',
              money: item.total_all,
              rowClass: 'sumRow'
            }
          }
          return item
        })
        this.pinnedBottomRowData = [
          {
            ...this.rows.pop()
          }
        ]
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    }
  }
}
</script>
